<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '秩序维护')[0].value" >
    <div style="width: 90%;margin-top: 2%;">
        <el-table :data="
            EmergenciesList"
                  style="width: 100%;height: 85%;"
                  empty-text="暂无数据"
                  v-loading="loding">
          <el-table-column prop="name"
                          label="名称"
                          align="center">
          </el-table-column>
          <el-table-column prop="description"
                          label="事件描述"
                          align="center">
          </el-table-column>
          <el-table-column prop="level"
                          label="严重等级"
                          align="center">
            <template #default="scope">
              <div style="text-align:center;margin-bottom:10px;"><span v-for="o in scope.row.level"
                      :key="o">
                  <el-image :src="Global.imgip + 'resources/images/icons/leave.png'"></el-image>
                </span></div>
            </template>
          </el-table-column>
          <el-table-column prop="satisfy"
                          label="处理满意度"
                          align="center">
            <template #default="scope">
              <el-progress :text-inside="true"
                          :stroke-width="22"
                          :percentage="EmergenciesModelList.filter(c=>c.emergenciesID==scope.row.id)[0]?.satisfaction"
                          status="success" />
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
              <div v-if="EmergenciesModelList.filter(c=>c.emergenciesID==scope.row.id).length==0">
                <el-button size="large"
                          type="primary"
                          @click="handle(scope.$index, scope.row)">处理</el-button>
                <el-button size="large"
                          type="danger"
                          @click="ignore(scope.$index, scope.row)">忽略</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-sizes="[5, 10, 15, 20]"
                      :page-size="pagesize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="EmergenciesTotal"
                      style="display: flex; justify-content: center;margin-top: 10px;">
        </el-pagination>
  </div>
  </ShowControl>
</template>
  <script>
import { mapState } from "vuex";
import emitter from '../../../unit/bus'
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["department"],
  components: {
    ShowControl,
  },
  data () {
    return {
      feedback: false,
      loding: false,
      caseID: localStorage.getItem("caseId"),
      flowID: localStorage.getItem("flowID"),
      currentPage: 1,
      pagesize: 5,
      EmergenciesList: [],
      EmergenciesModelList: [],
      EmergenciesTotal: 0,
      AllHandle: [],
      active_tab1: [],
      money: 0,
      complaint: {},
      EmergenciesInput: {
        round: null,
        currentPage: null,
        pagesize: null
      },
      childTitle: '',
      title: '秩序维护'
    };
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
    }),
  },
  created () {
    this.GetAllEmergenciesModel();
    this.GetAllEmergencies();
  },
  mounted() {
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/ExhibitionServices")
    },
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.GetAllEmergencies();
    },
    //当前页码
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.GetAllEmergencies();
    },
    GetAllEmergenciesModel () {
      this.$http.get('SModel/GetTypeSModel?round=' + this.Round + "&typename=S_Emergencies").then((res) => {
        if (res.success) {
          this.EmergenciesModelList = res.dynamicObj
        }
      })
    },
    GetAllEmergencies () {
      this.loading = true
      this.EmergenciesInput.round = parseInt(this.Round);
      this.EmergenciesInput.currentPage = this.currentPage;
      this.EmergenciesInput.pagesize = this.pagesize;
      this.$http.post('IEmergencies/GetAllEmergencies', this.EmergenciesInput).then((res) => {
        if (res.success) {
          this.EmergenciesList = res.dynamicObj
          this.EmergenciesTotal = res.totalRecord;
          this.loading = false
        }
      })
    },
    //获取所有的突发事件处理方式
    GetAllHandle () {
      this.$http.get('Handle/GetAllHandle?caseID=' + this.caseID).then((res) => {
        if (res.success) {
          this.AllHandle = res.dynamicObj
        }
      })
    },
    //表格中的处理
    handle (index, row) {
      this.$router.push({path:'EmergenciesEditCard',query:{id: row.id, tid : row.tID,uuid: row.uuid }})
    },
    //选择处理方式
    selected (key) {
      let arrIndex = this.active_tab1.indexOf(key.id);
      if (arrIndex > -1) {   // 已选中,点击取消
        this.active_tab1.splice(arrIndex, 1);
        this.money = this.money - key.cost
      } else {  // 未选中,点击选中
        this.active_tab1.push(key.id);
        this.money = this.money + key.cost
      }
      this.active_tab1.sort((a, b) => {
        return a - b // 按升序排
      })
    },
    returnview () {
      this.feedback = false;
      this.GetAllEmergenciesModel()
    },
    //忽略
    ignore (index, row) {
      let list = [{
        round: parseInt(this.Round),
        type: "S_Emergencies",
        uuid: row.uuid,
        sTTime: this.filter.formatDate(new Date()),
        state: this.Global.SModel.Create,
        handles: null,
        satisfaction: -10,
        cost: 0,
      }];
      this.$http
        .post('SModel/PushStrategy', this.Global.getsmodel(list))
        .then((res) => {
          if (res.success) {
            this.Global.sendmsgmd(`会展服务`, `处理突发事件花费0元`, 1);
            this.GetAllEmergenciesModel()
          } else {
            this.$message.error(res.message);
            return false;
          }
        });
    },
    Emergencieshandle () {
      if (this.flowID != this.Global.FlowList.执行) {
        this.$message.error("当前流程阶段不是执行，无法进行操作！");
        return;
      }
      if (this.active_tab1.length != 0 && !this.Global.GetBudget(this.money)) {
        return this.$message.error("金额不足");
      }
      let handleID = '';
      if (this.active_tab1.length != 0) {
        this.active_tab1.forEach(item => {
          handleID += item + ','
        });
        handleID = handleID.substring(0, handleID.length - 1)
      }
      let Satisfaction = 0;
      var tHandlesLength = this.complaint.tHandles.split(',').length
      for (let i = 0; i < this.active_tab1.length; i++) {
        if (this.complaint.tHandles.indexOf(this.active_tab1[i]) != -1) {
          Satisfaction += 1 / tHandlesLength * 100
        } else {
          Satisfaction += 10
        }
      }
      Satisfaction = Satisfaction > 100 ? 100 : Satisfaction
      let list = [{
        round: parseInt(this.Round),
        type: "S_Emergencies",
        uuid: this.complaint.uuid,
        sTTime: this.filter.formatDate(new Date()),
        state: this.Global.SModel.Create,
        handles: handleID,
        satisfaction: parseInt(Satisfaction),
        cost: this.money,
        emergenciesID: this.complaint.id
      }];
      this.$http
        .post("SModel/PushStrategy", this.Global.getsmodel(list))
        .then((res) => {
          if (res.success) {
            this.Global.sendmsgmd(
              "会展服务",
              "处理突发事件花费" + this.money + "元",
              1
            );
            var incomet = [{
              buissType: this.Global.PayType.秩序维护,
              round: this.Round,
              buissValue: this.money,
              buissId: this.complaint.id,
            }];
            this.API.pushIncomet(incomet, 0);
            this.imgs = (Satisfaction >= 0 && Satisfaction <= 20) ? 'resources/images/complaints/bad.png' : (Satisfaction > 20 && Satisfaction <= 80) ? 'resources/images/complaints/so-so.png' : 'resources/images/complaints/good.png'
            this.handleview = false;
            this.feedback = true;
            this.GetAllEmergenciesModel();
            emitter.emit("Emergencies", "发送")
            this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.normal,'秩序维护');
          } else {
            this.$message.error(res.message);
            return false;
          }
        });

    },
  },
};
  </script>
  
  <style scoped>
#Handle {
  background-color: orange;
}
.span {
  font-size: 30px;
}

.image {
  width: 100%;
  height: 100px;
  display: block;
}
</style>